import { Field } from "formik";

import { FormFieldWrapper } from "../../../../organisms/form-field-wrapper";
import { FormikFormInputText } from "../../form-input-text";

interface IProps {
  id?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export const FormFieldHobbyFreeText: React.FC<IProps> = ({
  id = "hobby",
  label = "Child's hobby or main interest",
  placeholder = "e.g. LEGO",
  required = false,
}) => (
  <FormFieldWrapper label={label} required={required} name={id}>
    <Field name={id} component={FormikFormInputText} placeholder={placeholder} />
  </FormFieldWrapper>
);
